document.addEventListener('DOMContentLoaded', function () {

  const tabs = document.querySelectorAll('.ctp-tab');
  const contents = document.querySelectorAll('.ctp-content');

  if (!tabs.length) return;

  tabs.forEach(tab => {

    tab.addEventListener('click', function () {

      const target = this.getAttribute('data-tab');

      tabs.forEach(btn => {
        btn.classList.remove('active');
      });

      contents.forEach(content => {
        content.classList.remove('active');
      });

      this.classList.add('active');

      const activeContent = document.getElementById(target);

      if (activeContent) {
        activeContent.classList.add('active');
      }

    });

  });

});